"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TriggerTextMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @class TriggerTextMixin */
/** @method */
var TriggerTextMixin = (0, _styledToken.default)({
  borderColor: 'TriggerText.borderBottomColor',
  borderColorHover: 'TriggerText.borderBottomColorHover',
  borderWidth: 'TriggerText.borderBottomWidth',
  borderStyle: 'TriggerText.borderBottomStyle',
  padding: 'TriggerText.padding'
}, function (_ref) {
  var borderColor = _ref.borderColor,
    borderColorHover = _ref.borderColorHover,
    _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? 1 : _ref$borderWidth,
    _ref$borderStyle = _ref.borderStyle,
    borderStyle = _ref$borderStyle === void 0 ? 'dashed' : _ref$borderStyle,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? 0 : _ref$padding;
  return "\n        display: inline;\n        color: inherit;\n        cursor: pointer;\n        font-weight: inherit;\n        font-size: inherit;\n        font-family: inherit;\n        background: none;\n        padding: " + padding + "px;\n        border: 0;\n        border-bottom: " + borderWidth + "px " + borderStyle + " " + (borderColor || '') + ";\n        user-select: text;\n\n        &:not(:disabled):hover {\n          border-bottom-color: " + (borderColorHover || '') + ";\n        }\n    ";
});
exports.TriggerTextMixin = TriggerTextMixin;